import React from "react";
import { Link } from "react-router-dom";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";

const WhyChooseFiveTwo = () => {

    return (
        <div className="why-choose-five-two about-why-choose-two">
            <div className="container">
                <div className="row gutter-y-40">
                    <div className="col-lg-4">
                        <div
                            className="why-choose-left-five animate fadeInLeft wow"
                            data-wow-duration="1500ms"
                            data-wow-delay="200ms"
                        >
                            <div className="heading-box">
                                <h2 className="heading-title">
                                    Customers are served behind the <span>digital marketing</span>
                                </h2>
                            </div>
                            <p className="lead">
                                Uniqo offers full range of consultancy &amp; training for data
                                consultation strategic ways for business.
                            </p>
                            <Link to="/Aboutus" className="btn btn-light btn-theme">
                                View More <span>+</span>
                            </Link>
                        </div>
                    </div>
                    <div className="col-lg-8">
                        <div className="why-choose-right-five">
                            <div className="row gutter-y-30">
                                <div className="col-lg-4 col-md-4">
                                    <div
                                        className="why-choose-box-five-two animate fadeInRight wow"
                                        data-wow-duration="1500ms"
                                        data-wow-delay="200ms"
                                    >
                                        <div className="why-choose-box-icon">
                                            <div
                                                className="circleGraphic"
                                                data-circle-options='{
                                           "color": "#C9A885",
                                           "value": 45
                                         }'
                                            />
                                            <span>45%</span>
                                            <CircularProgressbar
                                                value={45}
                                                styles={buildStyles({
                                                    pathColor: '#C9A885',
                                                    textColor: '#000',
                                                    trailColor: '#d6d6d6',
                                                })}
                                            />
                                        </div>
                                        <h4>Business Development</h4>
                                        <p>
                                            Consistently ranked among the top consulting firms across the
                                            nation.
                                        </p>
                                    </div>
                                </div>
                                <div className="col-lg-4 col-md-4">
                                    <div
                                        className="why-choose-box-five-two animate fadeInRight wow"
                                        data-wow-duration="1500ms"
                                        data-wow-delay="400ms"
                                    >
                                        <div className="why-choose-box-icon">
                                            <div
                                                className="circleGraphic"
                                                data-circle-options='{
                                           "color": "#C9A885",
                                           "value": 65
                                         }'
                                            />
                                            <span>65%</span>
                                            <CircularProgressbar
                                                value={65}
                                                styles={buildStyles({
                                                    pathColor: '#C9A885',
                                                    textColor: '#000',
                                                    trailColor: '#d6d6d6',
                                                })}
                                            />
                                        </div>
                                        <h4>Financial Reporting</h4>
                                        <p>
                                            Dedicated to providing personal attention to all our clients.
                                        </p>
                                    </div>
                                </div>
                                <div className="col-lg-4 col-md-4">
                                    <div
                                        className="why-choose-box-five-two animate fadeInRight wow"
                                        data-wow-duration="1500ms"
                                        data-wow-delay="600ms"
                                    >
                                        <div className="why-choose-box-icon">
                                            <div
                                                className="circleGraphic"
                                                data-circle-options='{
                                           "color": "#C9A885",
                                           "value": 85
                                         }'
                                            />
                                            <span>85%</span>
                                            <CircularProgressbar
                                                value={85}
                                                styles={buildStyles({
                                                    pathColor: '#C9A885',
                                                    textColor: '#000',
                                                    trailColor: '#d6d6d6',
                                                })}
                                            />
                                        </div>
                                        <h4>Investment Analysis</h4>
                                        <p>
                                            We take pride fighting for individuals, not big insurance
                                            companies.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div >

    )
}
export default WhyChooseFiveTwo;